import React from 'react';
import { GiBroom } from "react-icons/gi";
import { MdDoneAll } from "react-icons/md";
import { Row, Col, Button, Card, CardBody } from 'reactstrap';

//Componentes auxiliares
import CustomCheckbox from './CustomCheckbox';

class ChecksFilterManager extends React.Component {

    constructor() {
        super();

        this.state = {} //El state se llena automáticamente según el array de filteringOptions
    }

    render() {
        return (
            <Card>
                <CardBody>
                    <Row style={{ marginBottom: 10 }}>
                        <Col xs="8" md="8" lg="8" xl="8">
                            <div style={{ display: "table", overflow: "hidden", height: 42 }}>
                                <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                                    <h6 className="card-title noselect" style={{ cursor: "pointer", marginBottom: 0 }}>
                                        <p style={{ fontSize: 10, marginBottom: 0 }}>{this.props.title || "@Titulo"}</p>
                                    </h6>
                                </div>
                            </div>
                        </Col>

                        <Col xs="4" md="4" lg="4" xl="4" style={{ textAlign: "right" }}>
                            {this.props.actionButtons}

                            <Button
                                className="btn btn-default"
                                onClick={this.fastActionButtonClick}
                                key="actionButtonForDownloadSourcesFilterManager"
                                data-tut="reactour__mainLayout.filterManagerQuickButton"
                                style={{ padding: "3px 10px", backgroundColor: "transparent", color: "#65615c", marginLeft: 5 }}>

                                {this.getFastActionButtonIcon()}
                            </Button>
                        </Col>
                    </Row>

                    {this.getOptionsCheckboxes()}

                    <Row style={{ flexDirection: "column", alignItems: "center", paddingTop: 15, paddingLeft: "5%", paddingRight: "5%" }}
                        data-tut="reactour__processesRegistry.processesRegistryTablePaginationResume">
                        <p className="card-category" style={{ marginBottom: 5, fontSize: 10, textTransform: "uppercase" }}>
                            <b>{this.getQuantityDescription(this.props)}</b>
                        </p>
                    </Row>
                </CardBody>
            </Card>
        );
    }

    componentDidMount() {
        console.log(`DEBUG: ChecksFilterManager (${this.props.managerKey}) mounting`);
        console.log(`DEBUG: Props on mount:`, {
            filteringOptions: this.props.filteringOptions,
            filteringKey: this.props.filteringKey,
            originalFilters: this.props.originalFilters,
            preventAutoSelect: this.props.preventAutoSelect
        });
    }

    componentDidUpdate(prevProps, prevState) {
        console.log(`DEBUG: ChecksFilterManager (${this.props.managerKey}) updating`);
        console.log(`DEBUG: Current state:`, this.state);
        
        if (JSON.stringify(prevProps.originalData) !== JSON.stringify(this.props.originalData)) { 
            console.log(`DEBUG: originalData changed for ${this.props.managerKey}`);
            console.log(`DEBUG: New originalData length:`, this.props.originalData.length);
            
            if (!this.props.initialFilter) {
                if (JSON.stringify(this.props.originalFilters) !== JSON.stringify({})) {
                    console.log(`DEBUG: Using originalFilters:`, this.props.originalFilters);
                    this.setState(this.props.originalFilters);
                    this.props.filteredDataCallback(this.props.originalFilters);
                }
                else {
                    // Check if we should prevent auto-selection of all items
                    if (this.props.preventAutoSelect) {
                        // Initialize with empty filters
                        console.log(`DEBUG: preventAutoSelect is true, initializing with empty filters`);
                        let emptyFilters = {};
                        this.setState(emptyFilters);
                        this.props.filteredDataCallback(emptyFilters);
                    } else {
                        // Default behavior - select all items
                        console.log(`DEBUG: Auto-selecting all items`);
                        let allFiltersOnObject = {};
                        this.props.filteringOptions.forEach((optionItem, i) => {
                            const key = optionItem[this.props.filteringKey];
                            console.log(`DEBUG: Adding filter key:`, key, typeof key);
                            allFiltersOnObject[key] = true;
                        });
                        console.log(`DEBUG: Created filter object:`, allFiltersOnObject);
                        this.setState(allFiltersOnObject);
                        this.props.filteredDataCallback(allFiltersOnObject);
                    }
                }
            }
            else {
                console.log(`DEBUG: Using initialFilter:`, this.props.initialFilter);
                let allFiltersOnObject = {};
                allFiltersOnObject[this.props.initialFilter] = true;
                this.setState(allFiltersOnObject);
                this.props.filteredDataCallback(allFiltersOnObject);
            }
        }
        
        // Log when filter options change
        if (JSON.stringify(prevProps.filteringOptions) !== JSON.stringify(this.props.filteringOptions)) {
            console.log(`DEBUG: filteringOptions changed for ${this.props.managerKey}`, this.props.filteringOptions);
        }
    }

    //Métodos para renderizado:
    fastActionButtonClick = () => {
        let theBroomShouldBeDisplayed = this.shouldTheBroomBeDisplayed();

        if (theBroomShouldBeDisplayed) {
            let updateObject = { ...this.state };
            let updateObjectKeys = Object.keys(updateObject);

            updateObjectKeys.forEach((key) => { updateObject[key] = false });

            this.setState(updateObject);
            this.props.filteredDataCallback(updateObject);
        }
        else {
            let updateObject = {};
            this.props.filteringOptions.forEach((optionItem) => { updateObject[optionItem[this.props.filteringKey]] = true });

            this.setState(updateObject);
            this.props.filteredDataCallback(updateObject);
        }
    }

    getFastActionButtonIcon = () => {
        return ((this.shouldTheBroomBeDisplayed()) ? <GiBroom /> : <MdDoneAll />);
    }

    getOptionsCheckboxes = () => {
        return this.props.filteringOptions.map((optionItem, i) => {
            const filterKey = optionItem[this.props.filteringKey];
            let checkedValue = this.state[filterKey];
            if (checkedValue === undefined) { checkedValue = false; };
            
            console.log(`DEBUG: Rendering checkbox for ${this.props.managerKey}:`, { 
                filterKey, 
                filterKeyType: typeof filterKey,
                checkedValue 
            });

            return (
                <CustomCheckbox
                    checked={checkedValue}
                    key={this.props.managerKey + ".checkbox." + i}
                    itemRendering={this.props.itemRendering(optionItem)}
                    onChange={(newValue) => {
                        console.log(`DEBUG: Checkbox changed for ${this.props.managerKey}:`, {
                            filterKey,
                            filterKeyType: typeof filterKey,
                            oldValue: checkedValue,
                            newValue
                        });
                        
                        let newState = { ...this.state };
                        newState[filterKey] = newValue;
                        
                        console.log(`DEBUG: New filter state for ${this.props.managerKey}:`, newState);
                        
                        this.props.filteredDataCallback(newState);
                        this.setState({ ...newState });
                    }} />
            );
        })
    }

    getQuantityDescription = (props) => {
        let activeQuantity = props.activeQuantity;
        if (props.activeQuantity >= props.totalRegisters) { activeQuantity = props.totalRegisters }
        if (props.totalRegisters < props.activeQuantity) { activeQuantity = props.totalRegisters }

        return ("Estoy viendo " + activeQuantity + " registros de " + props.totalRegisters);
    }

    //Métodos operativos:
    shouldTheBroomBeDisplayed = () => {
        let activeCheckboxes = 0;
        let stateKeys = Object.keys(this.state);

        for (let i = 0; i < stateKeys.length; i++) { if (this.state[stateKeys[i]]) { activeCheckboxes++; } }
        
        // If no filters are selected and we're in prevent auto-select mode, show checkmark (select all)
        if (activeCheckboxes === 0 && this.props.preventAutoSelect) {
            return false;
        }
        
        return (activeCheckboxes === this.props.filteringOptions.length);
    }

}

export default ChecksFilterManager;